import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type EmptyStateProps = {
  title: ReactNode;
  description?: ReactNode;
  /** One action, rendered as given (a Button, a Link). */
  action?: ReactNode;
  className?: string;
};

/**
 * Empty state of the design system (§5): the warm ground, one display line,
 * one action. No illustrations.
 */
export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl bg-accent-warm-soft px-6 py-12 text-center",
        className
      )}
    >
      <p className="font-display text-xl font-medium leading-tight tracking-[-0.01em] text-app-fg-strong [text-wrap:balance]">
        {title}
      </p>
      {description ? (
        <p className="mt-2 max-w-sm text-sm text-accent-warm-strong">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
